export default "__VITE_ASSET__DHTcz1id__"